'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TotalHeader(props) {
  var t = props.t,
      components = props.components;

  // Styles defined here because editor lacking this component
  //const styleTotalHeader = {
  //  color: '#333',
  //  fontSize: '15px',
  //  fontWeight: '500',
  //  fontStyle: 'normal',
  //  textDecoration: 'none',
  //  fontFamily: 'Arial, sans-serif',
  //};

  var styleTotalHeader = {
    color: components.PriceHeaderTotalText.color,
    fontSize: components.PriceHeaderTotalText.fontSize,
    fontWeight: components.PriceHeaderTotalText.fontWeight,
    fontStyle: components.PriceHeaderTotalText.fontStyle,
    textDecoration: components.PriceHeaderTotalText.textDecoration,
    fontFamily: components.PriceHeaderTotalText.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TotalHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement('td', { style: { padding: '0', width: '70%' } }),
        _react2.default.createElement(
          'td',
          { style: { padding: '0', textAlign: 'left', width: '30%' } },
          _react2.default.createElement(
            'span',
            { style: styleTotalHeader },
            t('air.total')
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(TotalHeader));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/TotalHeader.jsx
// module id = 1487
// module chunks = 0